import Vue from 'vue';
import productBundleTransformer from './../../transformers/productBundle';
import store from './../../store';

const success = ({ data }, resolve) => resolve(productBundleTransformer.fetch(data));

const failed = () => {};


export default id => (
  new Promise((resolve, reject) => {
    const products = store.state.product.items.filter(p => (
      id.toString() === p.id.toString()
    ));

    if (products.length > 0) {
      return resolve(products[0]);
    }

    return Vue.$http.get(`/product_bundles/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productBundle/show.js